import { render } from "./DispatchOrderModal.vue?vue&type=template&id=25ecb668"
import script from "./DispatchOrderModal.vue?vue&type=script&lang=js"
export * from "./DispatchOrderModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__